// src/features/equipment/services/equipmentTemplates.js
import { apiClient } from '../../../services/api/client';

const BASE = '/api/v1/rooms-equipment/equipment-templates';

export const equipmentTemplatesAPI = {
  list: (params = {}) =>
    apiClient.get(`${BASE}/`, { params }),

  getById: (templateId) =>
    apiClient.get(`${BASE}/${templateId}`),

  create: (data) =>
    apiClient.post(`${BASE}/`, data),

  update: (templateId, data) =>
    apiClient.put(`${BASE}/${templateId}`, data),

  delete: (templateId) =>
    apiClient.delete(`${BASE}/${templateId}`),

  linkTaskTemplate: (templateId, taskTemplateId) =>
    apiClient.post(`${BASE}/${templateId}/task-templates/${taskTemplateId}`),

  unlinkTaskTemplate: (templateId, taskTemplateId) =>
    apiClient.delete(`${BASE}/${templateId}/task-templates/${taskTemplateId}`),
};
